import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './App.css'
import { initializeTracking } from './utils/tracking/tracking'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Defer non-critical tracking initialization until after page is interactive
// Use requestIdleCallback if available, fallback to setTimeout
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => {
    initializeTracking(
      import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
      import.meta.env.VITE_FACEBOOK_PIXEL_ID,
      import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
      import.meta.env.VITE_CLARITY_PROJECT_ID
    );
  }, { timeout: 3000 });
} else {
  // Fallback: defer tracking by 2 seconds on browsers without requestIdleCallback
  setTimeout(() => {
    initializeTracking(
      import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
      import.meta.env.VITE_FACEBOOK_PIXEL_ID,
      import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
      import.meta.env.VITE_CLARITY_PROJECT_ID
    );
  }, 2000);
}
